var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 36,
    viewBox: "0 0 49 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 11V6a2 2 0 0 0-2-2H12a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h21a2 2 0 0 0 2-2v-5",
    stroke: "#2A4686",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 16.673a.8.8 0 1 0 0 1.6v-1.6zm16.255 1.365a.8.8 0 0 0 0-1.131l-5.092-5.091a.8.8 0 0 0-1.131 1.131l4.526 4.526-4.526 4.525a.8.8 0 0 0 1.131 1.131l5.092-5.09zm-16.255.235h15.689v-1.6H31.75v1.6z",
    fill: "#2A4686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35H1",
    stroke: "#2A4686",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2 11.108a.8.8 0 0 0 1.6 0h-1.6zm1.6 13.784a.8.8 0 0 0-1.6 0h1.6zM10 1.8h25V.2H10v1.6zM7.8 35V4H6.2v31h1.6zM37.2 4v7.108h1.6V4h-1.6zm0 20.892V35h1.6V24.892h-1.6zM35 1.8A2.2 2.2 0 0 1 37.2 4h1.6A3.8 3.8 0 0 0 35 .2v1.6zM10 .2A3.8 3.8 0 0 0 6.2 4h1.6A2.2 2.2 0 0 1 10 1.8V.2z",
    fill: "#2A4686"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A4686",
    strokeWidth: 1.6,
    d: "M22.8 4v28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5h-4",
    stroke: "#2A4686",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckout);
export default __webpack_public_path__ + "static/media/iconCheckout.b3bdabaa4335927367e9c1fb56e65937.svg";
export { ForwardRef as ReactComponent };